export default "__VITE_ASSET__c7b1a475__"